export enum EnumEstadoDesviacion {
  EnConstruccion = 1,
  RegistroAnalisisCausal = 2,
  AccionesEjecucion = 3,
  VerificacionCierreAcciones = 4,
  Cerrado = 5,
  CerradoObservaciones = 6,
  CerradoPlanAccion = 7,
  Rechazado = 8,
  ValidaInformacionInicial = 9,
  RegistroCausasInmediatas = 10,
  AccionesCausasRechazadas = 11,
  VerificacionCausasRechazadas = 12,
  RegistroAmbitosGestion = 13,
}
